/**
 * Created by admin on 06.06.2017.
 */
export class DateUtility {
    static diffDate(end, start): number {
        return this.parseRussian(end).getFullYear() - this.parseRussian(start).getFullYear();
    }

    static diffDateNew(end, start):number{
        return new Date(end).getFullYear() - new Date(start).getFullYear();
    }

    static diffDateYearsString(diff:number):string{
        if(diff> 10 && diff<15)
            return "лет";
        let result:string;
        let lastDigit:string = diff.toString().split("").pop();
        switch(lastDigit){
            case "1":
                result = "год";
            break;
            case "2":
            case "3":
            case "4":
                result = "года";
            break;
            default:
                result = "лет";
            break
        }
        return result;
    }

    static leftLessOneMonth(start:Date, end:Date):boolean{
        let startClone:Date = new Date(start);
        startClone.setMonth(startClone.getMonth() + 1)
        return startClone >= end;
    }
    static dateCompare(date1, date2):boolean{
        return new Date(date1).getTime() == new Date(date2).getTime();
    }

    static parseRussian(str): Date {
        var parts = str.split('.');
        return new Date(parts[2], parts[1] - 1, parts[0]);
    }

    static parseDateWithLeadZero(date) {
        return this.LdgZero(date.getDate()) + "." + this.LdgZero(date.getMonth() + 1) + "." + date.getFullYear();
    }

    static getPeriod():string{
        return this.LdgZero(new Date().getMonth() + 1) + "." + new Date().getFullYear();
    }
    static LdgZero(n) {
        if (n < 10 && n != 0)
            return "0" + n;
        else
            return n;
    }

    static formatTimespan(millis:number):string{
        millis = millis | 0;
        var minutes = Math.floor(millis / 60000);
        var seconds = ((millis % 60000) / 1000).toFixed(0);
        var mils = (millis + "").slice(-3);
        return `${minutes} м ${seconds} с ${mils} мс`;
    }

}